import PageModule from "@eisinc/Overrides/Pages/Header";

export * from "@eisinc/Overrides/Pages/Header";

export default PageModule;
